// Environment-aware configuration
const config = {
  // Base URL for the application - always use relative paths for maximum compatibility
  baseUrl: '',

  // API endpoints - always use relative paths
  apiUrl: '/api',

  // Clerk publishable key
  clerkPublishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY,

  // Stripe public key
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,

  // Helper function to normalize URLs - handle both internal and external URLs correctly
  normalizeUrl: (url) => {
    console.log(`Normalizing URL: ${url}`);
    
    if (!url) {
      console.error('Empty URL provided to normalizeUrl');
      return '/';
    }
    
    // Special case for Stripe URLs - always use as is
    if (url.includes('stripe.com') || url.includes('billing.stripe.com')) {
      console.log(`Detected Stripe URL, keeping as is: ${url}`);
      return url;
    }
    
    // If it's an absolute URL with our domain, extract the path
    if (url.startsWith('http') &&
        (url.includes(window.location.hostname) || url.includes('github.dev'))) {
      try {
        const urlObj = new URL(url);
        const path = urlObj.pathname + urlObj.search + urlObj.hash;
        console.log(`Converted domain URL to path: ${path}`);
        return path;
      } catch (e) {
        console.error('Error parsing URL:', e);
      }
    }

    // If it's an absolute URL to an external site, return it directly
    if (url.startsWith('http')) {
      console.log(`External URL, keeping as is: ${url}`);
      return url;
    }

    // Ensure the URL starts with a slash for relative paths
    if (!url.startsWith('/')) {
      url = '/' + url;
      console.log(`Added leading slash: ${url}`);
    }

    // Return a clean relative path
    console.log(`Final normalized URL: ${url}`);
    return url;
  }
};

export default config;